export const STAGE_KEY = {
  PreApplication: "PreApplication",
  AlreadyApplied: "AlreadyApplied",
  GotAdmission: "GotAdmission",
  AlreadyAtUniversity: "AlreadyAtUniversity",
};
